import src from "IMAGE";
export default { src, width: 244, height: 61, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AC8vL+4nJyfMJSUlN3t7e3KBgYF1kJCQhHx8fHGFhYV5ADIyMvIoKCjPMzMzRoqKin6ampqLgYGBc4qKin2cnJyPUEYb9refePQAAAAASUVORK5CYII=", blurWidth: 8, blurHeight: 2 }
